import { CircularProgress } from "@mui/material";
import blankProfile from "../../component/schoolAdminPortal/images/blank-profile.png";
const ImageUploadContainer = ({
  id,
  logoUrl,
  handleUpload,
  label,
  loading,
}) => {
  return (
    <div className="d-flex-align-cent flex-direction-r gap-10">
      <div className="position-relative">
        <img
          src={logoUrl ? logoUrl : blankProfile}
          className="profileStyle"
          alt=""
        ></img>
        {loading && (
          <div className="position-absolute top-0 w-100 h-100">
            <CircularProgress
              color="success"
              sx={{ fontSize: 40, color: "#00DFA2" }}
              disableShrink
              className="w-100 h-100"
            />
          </div>
        )}
      </div>
      <div className="w-100 oflow-hidden">
        <label
          htmlFor={id}
          className="form-control semi-bold txt-blue cp mg-top-10 text-center text-width-auto"
        >
          {label}
        </label>
        <input
          type="file"
          name="photo"
          accept="image/png, image/gif, image/jpeg"
          id={id}
          onChange={(event) => handleUpload(event.target.files[0])}
        />
      </div>
    </div>
  );
};

export default ImageUploadContainer;
